module.exports = __webpack_public_path__ + "img/container-3-v.46053957.png";